export function isWindows() {
  if (!navigator.platform) return false;

  return navigator.platform?.indexOf('Win') > -1;
}

export function isZoom() {
  if (!navigator.userAgent) return false;

  return navigator.userAgent.toLocaleLowerCase().indexOf('zoom') > -1;
}

export function isZoomAndWindows() {
  return isWindows() && isZoom();
}
